


  export default {
    props: {
      region: {
        type: String,
        default: 'uk'
      }
    },
    // use store getRegion to check uk / rest of world
    data() {
      return {
        ready:false
      }
    },
    head() {
    if(this.ready){
    return {
            script: [{ type: 'application/ld+json', json: this.structuredData }]
        }
      }
    },
    computed: {
      // add ofqual for uk can pass a prop maybe
      structuredData() {
        if(this.$props.region === 'uk') {
        return {
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "The TEFL Org",
          "url": "https://www.tefl.org/",
          "sameAs": "https://www.tefl.org/",
          "hasCredential": [
            {
            "@type":"EducationalOccupationalCredential",
            "credentialCategory":"accreditation",
            "about":"DEAC/AQC",
            "recognizedBy":"The Distance Education Accrediting Commission",
            "url":"https://www.deac.org/AQC/"
            },
            {
            "@type":"EducationalOccupationalCredential",
            "credentialCategory":"accreditation",
            "about":"Ofqual",
            "recognizedBy":"The Distance Education Accrediting Commission",
            "url":"https://www.gov.uk/government/organisations/ofqual"
            },
            {
            "@type":"EducationalOccupationalCredential",
            "credentialCategory":"accredication",
            "about":"BAC",
            "recognizedBy":"The Distance Education Accrediting Commission",
            "url":"https://www.the-bac.org/"
            },
            {
            "@type":"EducationalOccupationalCredential",
            "credentialCategory":"accreditation",
            "about":"SQA",
            "recognizedBy":"The Distance Education Accrediting Commission",
            "url":"https://www.sqa.org.uk/"
            },
            // {
            // "@type":"EducationalOccupationalCredential",
            // "credentialCategory":"accreditation",
            // "about":"ODLQC",
            // "recognizedBy":"The Distance Education Accrediting Commission",
            // "url":"https://www.odlqc.org.uk/"
            // },
            {
            "@type":"EducationalOccupationalCredential",
            "credentialCategory":"accreditation",
            "about":"UKRLP",
            "recognizedBy":"UK Register of Learning Providers",
            "url":"https://www.ukrlp.co.uk/"
            }
          ]
        }
      } else {
        return {
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "The TEFL Org",
          "url": "https://www.tefl.org/",
          "sameAs": "https://www.tefl.org/",
          "hasCredential": [
            {
            "@type":"EducationalOccupationalCredential",
            "credentialCategory":"accreditation",
            "about":"DEAC/AQC",
            "recognizedBy":"The Distance Education Accrediting Commission",
            "url":"https://www.deac.org/AQC/"
            },
            {
            "@type":"EducationalOccupationalCredential",
            "credentialCategory":"accredication",
            "about":"BAC",
            "recognizedBy":"The Distance Education Accrediting Commission",
            "url":"https://www.the-bac.org/"
            },
            {
            "@type":"EducationalOccupationalCredential",
            "credentialCategory":"accreditation",
            "about":"SQA",
            "recognizedBy":"The Distance Education Accrediting Commission",
            "url":"https://www.sqa.org.uk/"
            },
            // {
            // "@type":"EducationalOccupationalCredential",
            // "credentialCategory":"accreditation",
            // "about":"ODLQC",
            // "recognizedBy":"The Distance Education Accrediting Commission",
            // "url":"https://www.odlqc.org.uk/"
            // },
            {
            "@type":"EducationalOccupationalCredential",
            "credentialCategory":"accreditation",
            "about":"UKRLP",
            "recognizedBy":"UK Register of Learning Providers",
            "url":"https://www.ukrlp.co.uk/"
            }
          ]
        }
      }
      }
    },
    mounted() {
      this.ready = true
    }
  }
